export const getUser = state => state.user;
export const getIsAuthenticated = state => state.user != null && state.user.id != null;
export const getIsClubOwner = clubId => state => state.user.clubs[Number(clubId)];
